module.exports = require("core-js/library/fn/object/get-own-property-names");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/get-own-property-names.js
// module id = 717
// module chunks = 101